import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from './avatar';
import { MaleGlyph, FemaleGlyph } from './gender-glyphs';
import { UserCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * GenderAvatar component that displays:
 * - Profile picture if available (highest priority)
 * - Male glyph if gender is 'male' and no picture
 * - Female glyph if gender is 'female' and no picture
 * - UserCircle for other/prefer_not_to_say/null/invalid genders
 */
const GenderAvatar = ({ 
  profilePicture, 
  gender, 
  size = 64, 
  className 
}) => {
  // Determine what to show in fallback
  const getFallback = () => {
    if (gender === 'male') {
      return <MaleGlyph size={size} className="w-full h-full" />;
    }
    if (gender === 'female') {
      return <FemaleGlyph size={size} className="w-full h-full" />;
    }
    // Default for other, prefer_not_to_say, null, undefined, or invalid
    return <UserCircle className="w-full h-full text-gray-400" size={size} />;
  };

  return (
    <Avatar className={cn('w-full h-full', className)} style={{ width: size, height: size }}>
      <AvatarImage 
        src={profilePicture || undefined} 
        alt="Profile" 
        className={className}
      />
      <AvatarFallback className="flex items-center justify-center">
        {getFallback()}
      </AvatarFallback>
    </Avatar>
  );
};

export default GenderAvatar;

